"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestActionType = void 0;
var RequestActionType;
(function (RequestActionType) {
    RequestActionType["Acknowledge"] = "Acknowledge";
    RequestActionType["Expired"] = "Expired";
})(RequestActionType = exports.RequestActionType || (exports.RequestActionType = {}));
